
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface PersonNameFieldsProps {
  firstName: string;
  setFirstName: (value: string) => void;
  lastName: string;
  setLastName: (value: string) => void;
  academicTitle?: string;
  setAcademicTitle?: (value: string) => void;
  formalSalutation?: string;
  setFormalSalutation?: (value: string) => void;
  required?: boolean;
  errors?: {
    firstName?: string;
    lastName?: string;
    academicTitle?: string;
    formalSalutation?: string;
  }
}

const PersonNameFields: React.FC<PersonNameFieldsProps> = ({
  firstName,
  setFirstName,
  lastName,
  setLastName,
  academicTitle = "",
  setAcademicTitle,
  required = false,
  errors = {}
}) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">

        <div className="space-y-2">
          <Label htmlFor="academicTitle">Titulus</Label>
          <Input
            id="academicTitle"
            value={academicTitle}
            onChange={(e) => setAcademicTitle && setAcademicTitle(e.target.value)}
            placeholder="pl. Dr., Prof."
            className={errors.academicTitle ? "border-red-500" : ""}
          />
          {errors.academicTitle && (
            <p className="text-sm text-red-500 mt-1">{errors.academicTitle}</p>
          )}
        </div>
        <div className="space-y-2  col-span-2">
          <Label htmlFor="lastName">
            Vezetéknév{required && <span className="text-red-500 ml-1">*</span>}
          </Label>
          <Input
            id="lastName"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder="Vezetéknév"
            required={required}
            className={errors.lastName ? "border-red-500" : ""}
          />
          {errors.lastName && (
            <p className="text-sm text-red-500 mt-1">{errors.lastName}</p>
          )}
        </div>
        <div className="space-y-2  col-span-2">
          <Label htmlFor="firstName">
            Keresztnév{required && <span className="text-red-500 ml-1">*</span>}
          </Label>
          <Input
            id="firstName"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder="Keresztnév"
            required={required}
            className={errors.firstName ? "border-red-500" : ""}
          />
          {errors.firstName && (
            <p className="text-sm text-red-500 mt-1">{errors.firstName}</p>
          )}
        </div>

      </div>
    </div>
  );
};

export default PersonNameFields;
